import { render } from "./TrainingSectionHero.vue?vue&type=template&id=25779999&scoped=true"
import script from "./TrainingSectionHero.vue?vue&type=script&lang=js"
export * from "./TrainingSectionHero.vue?vue&type=script&lang=js"

import "./TrainingSectionHero.vue?vue&type=style&index=0&id=25779999&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25779999"]])

export default __exports__